import { render, staticRenderFns } from "./qkExpertDetail.vue?vue&type=template&id=566df4e1&scoped=true"
import script from "./qkExpertDetail.vue?vue&type=script&lang=js"
export * from "./qkExpertDetail.vue?vue&type=script&lang=js"
import style0 from "./qkExpertDetail.vue?vue&type=style&index=0&id=566df4e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566df4e1",
  null
  
)

export default component.exports